import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TaxwdService, templateUrlConfigTax } from './../_service_tax';
import { MaterialModule } from 'jk-service';
import { TaxwdEditComponent } from './../_edit_tax';
import { UiModeType, PageKind } from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';



@Component({
  selector: 'app-taxpi92-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigTax.taxpi92_detail,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Taxpi92DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'taxpi92-detail';
  constructor() {
    super();
    this.srv = new TaxwdService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'WD001=WC001,WD002=WC002';
    this.masterEditPage = TaxwdEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'WD004', sort: 'asc', defaultSort: null, pageKind: this.pageKind };

    this.constructorInit(); // ###

  }



}
